import React from 'react';
import image from '../../assets/images/image.png'; // Adjust the path as necessary

const LandingAboutSection = () => {
  return (
    <div className="bg-gray-100 py-10 px-4">
      <div className="container mx-auto flex flex-col items-center md:flex-row">
        <img src={image} alt="Shahab" className="w-full md:w-1/2 mb-6 md:mb-0" />
        <div className="md:w-1/2 md:pl-10">
          <h1 className="text-4xl font-bold text-orange-600 mb-4">Hi! I'm Shahab.</h1>
          <p className="text-xl mb-6">
            I'm a <span className="text-green-700 font-bold">Machine Learning Engineer</span> with a knack for music and juggling.
          </p>
          <button className="bg-orange-500 text-white py-2 px-4 rounded hover:bg-orange-600">Tell me more!</button>
        </div>
      </div>
    </div>
  );
};

export default LandingAboutSection;
